import { ContentType } from "@dimensional-engineering/dimensional-models";

import styles from "./SpectrumsDeltaView.module.css";

import { useStaggeredOpacity } from "@/helpers/useStaggeredOpacity";
import { SpectrumsWithPreviousScores } from "@/components/shared/Spectrum/Spectrums";

type Props = {
  slug: string;
};

export default function SpectrumsDeltaView(props: Props) {
  const opacity = useStaggeredOpacity(3);

  return (
    <div className={styles.main}>
      <p style={{ opacity: opacity.step1 }} className={styles.topText}>
        CHANGES
      </p>
      <div style={{ opacity: opacity.step2 }} className={styles.spectrumDiv}>
        <SpectrumsWithPreviousScores
          contentIdentifier={{
            contentType: ContentType.dimensionSummary,
            contentSlug: props.slug,
          }}
          otherPublicProfile={null}
          noMargin
        />
      </div>
      <p style={{ opacity: opacity.step3 }} className={styles.bottomText}>
        {"Here's how each component has changed."}
      </p>
    </div>
  );
}
